import { Card, CardBody, Col, Table } from 'reactstrap'
import GridOptionTableHead from './GridOptionTableHead'
import GridOptionTableBody from './GridOptionTableBody'
import { GridOptions } from '../../../../Utils/Constants'
import { gridData } from '../../../../Data/Ui-Kits/Grid/GridData'
import CardHeaderCommon from '../../../../Utils/CommonComponents/CardHeaderCommon'

const GridOptionsCart = () => {
  return (
    <Col sm="12">
      <Card>
        <CardHeaderCommon title={GridOptions} span={gridData} />
        <CardBody>
          <div className="table-responsive theme-scrollbar">
            <Table bordered striped responsive>
              <GridOptionTableHead />
              <GridOptionTableBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default GridOptionsCart